export default __webpack_public_path__ + "4a0f669dcac91b5240297cd225e3cd8d.jpeg";